import {Routes} from '@angular/router';
import {PlatformLinkCreatorComponent} from '@shared/components/platform-tool/platform-link-creator/platform-link-creator.component';
import {PlatformToolContainerComponent} from '@shared/components/platform-tool/platform-tool-container/platform-tool-container.component';


export const expertServicesRoutes: Routes = [
  {
    path: 'expert-services/analytics',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'expert-services/solutions',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'expert-services/admin/analytics',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'expert-services/admin/usage-reports',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'expert-services/workspace',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'expert-services/workspaces/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'expert-services/service-provider/services',
    component: PlatformLinkCreatorComponent
  }/*,
  {
    path: 'expert-services/service-provider/templates',
    component: PlatformLinkCreatorComponent
  }*/,
  {
    path: 'expert-services/service-provider/consultants',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'expert-services/services',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'expert-services/service-workspace',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'expert-services/service-workspace/article/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'expert-services/service-workspace/documents/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'expert-services/service-workspace/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'expert-services/consultants',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'expert-services/clients',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'expert-services/companies',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'expert-services/companies/:magicLinkId',
    component: PlatformToolContainerComponent
  }
];
